/**
 * MODULE: domain/pages/frontend/utils/pageAiUtils.ts
 * PURPOSE: Types and helpers for Pages /ai slash commands
 */

export type PageAiPreset = 'summarise' | 'draft_email' | 'call_prep' | 'custom';

export type PageAiBlockStatus = 'loading' | 'complete' | 'error';

export const PAGE_AI_EXCERPT_LIMIT = 8000;

export function trimPageExcerpt(text: string): string {
  const trimmed = text.trim();
  if (trimmed.length <= PAGE_AI_EXCERPT_LIMIT) {
    return trimmed;
  }
  return `${trimmed.slice(0, PAGE_AI_EXCERPT_LIMIT - 3).trimEnd()}...`;
}

export function pageAiPresetLabel(preset: PageAiPreset): string {
  switch (preset) {
    case 'summarise':
      return 'Summarise page';
    case 'draft_email':
      return 'Draft sales email';
    case 'call_prep':
      return 'Call prep notes';
    case 'custom':
      return 'AI write';
    default:
      return 'AI response';
  }
}

export function isPagesAiEnabled(): boolean {
  return import.meta.env.VITE_PAGES_AI_DISABLED !== '1';
}
